const LENGTH_OF_CHECK_INTERVAL = 1000 * 60 * 2; // 2 minutes
const TIMERS_SHOULD_RUN = false;

const SHOW_DELEGATES = true;

export { LENGTH_OF_CHECK_INTERVAL, TIMERS_SHOULD_RUN, SHOW_DELEGATES };
